import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withFields } from '../fields'
import { get } from 'lodash'
import addressValidationActions from './address-validation-actions'
import AddressPicker from './address-picker'

/*

Used to validate addresses (typically on step-2). If an address supplied to the validateAddress()
action is not valid, state.addressValidation.potentialAddresses will be populated. If the 
components/address-picker.tsx component is present, it will display based on this value and
will handle the other nessessary actions.

If the user selects "I am unable to find my address" in the components/address-picker component, 
the ignoreAddresses() action is automatically fired which updates a field called state.fields.addressNotFound
to be true. This field must be supplied in the form submission.

*/


const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    addressValidation: state.addressValidation
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        addressValidation: bindActionCreators( addressValidationActions, dispatch )
    }
})


export function withAddressValidation (Wrapped:React.ComponentClass) {
    return connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, {}>{


        componentWillUnmount(){
            console.log("Clear existing address validation state")
            this.props.actions.addressValidation.clearPotentialAddresses()
        }


        onAddressSelected(address){
            console.log("Address selected")
            this.props.actions.addressValidation.selectNewAddress(address)
        }

        
        onNoAddressSelected(){
            console.log("No address selected")
            this.props.actions.addressValidation.ignoreAddresses()
        }
        

        render(){
            return (
                <div>
                    <AddressPicker 
                        addresses= { this.props.addressValidation.potentialAddresses }
                        onSelected= { this.onAddressSelected.bind(this) }
                        onNoAddressSelected= { this.onNoAddressSelected.bind(this) }                        
                    />
                    <Wrapped { ...this.props }/>
                </div>
            )
        }

    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/address-validation/index.tsx